import type { FaireProductEntity } from "../../entity_types/product";

export const p_4b8uf3vqbd: FaireProductEntity = {
  token: "p_4b8uf3vqbd",
  type: "product",
  name: "Cartoon Jumbo Mystery Squishy Dumpling Realistic Steamed Bun Stress Relief Squeeze Toy",
  brandToken: "b_9krr246qu7",
  brandName: "Auraquise",
  imageUrl:
    "https://cdn.faire.com/fastly/04853c2f20e3e5ce683b3e54fd5e64ac25779dfdd19dfbabd5389ec5ae083d64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7ea6a55a3a5888cf1fbc998d73aea3ec3627516e6d7e960171821b5059876f5.jpeg",
    "https://cdn.faire.com/fastly/69e64ea122ed137095d008906d3cb2bfbc3e44e3a78ce50e71b67a08624bd9a7.jpeg",
    "https://cdn.faire.com/fastly/bad4241f26f2a627178340b42638c82aa0c26841f50f4354709dee5238700407.jpeg",
    "https://cdn.faire.com/fastly/a1928dc3fab3a89dfa89edf896e57292940715bb7023436961ec9dd478f4c81f.jpeg",
    "https://cdn.faire.com/fastly/5fc647d1b91587af7f93cab4e83b2196f00feee23c27a819380d96ef5a398451.jpeg",
    "https://cdn.faire.com/fastly/ab0e17f7fe1f3cb13a57140f9de616903e1d14161cec81a80f9f3946dc36f2aa.jpeg",
    "https://cdn.faire.com/fastly/fe18a12b6b56468ea50a4d9196bd98ca09c4324019ac58e7120945f1dd7c10ee.jpeg",
    "https://cdn.faire.com/fastly/6429df03324e217d2e7f3395d6f711b7002c084099216ee08c2f3811acd2564e.jpeg",
    "https://cdn.faire.com/fastly/9a8b50e48f3cd3a6f9f812c5145637c1f1bb333abf0922250664548fc48def71.jpeg",
    "https://cdn.faire.com/fastly/9ec5fc8073442eb08088484070c4fb375d311ffc993cc5665f999d2177ca2e0c.jpeg",
    "https://cdn.faire.com/fastly/f2340656349082e443428dea6fdc0bb2b229e4edf7ac430e8c494cef615b316b.jpeg",
    "https://cdn.faire.com/fastly/2cabec585edfec8dfad441bdad3fa673eedae7e9f86408b08421419ddc791d2e.jpeg",
  ],
  priceDollars: 6.99,
  description:
    'Notes:\n\n1️⃣ Random Color for Single Orders\n\n2️⃣ Pre-Order Item: This product is currently a very popular item and is in the pre-order stage. The estimated shipping time is about 3 weeks after the order is placed. Please place your order only if you are comfortable with this waiting time.\n\n3️⃣ Includes Steamer Basket: Each dumpling squishy comes with a small steamer basket included. 🥟\nSize Notice:\n\nThis Squishy Dumpling comes in two sizes.\n\nSmall: 5.3 × 4.5 cm (clearly labeled in the product options)\n\nLarge: 8.5 × 5.5 cm\n\nIf the option does not specify "Small", it will default to the Large size. Please check the option name carefully before placing your order.',
  tags: [],
  msrpDollars: 13.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:33.873Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
